export enum resetType {
    password = 'password',
    credential = 'credential'
}